module.exports = __webpack_public_path__ + "static/media/1017109.75773c49.png";